import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

import { Grid, Button } from '@material-ui/core';

import { styles } from './styles';

class ButtonComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { className, classes } = this.props;
    let buttonBgColor = this.props.style.background;
    let buttonTextColor = this.props.style.buttonTextColor;

    function onMouseOver(e) {
      if (e.currentTarget !== null) {
        e.currentTarget.style.background = buttonTextColor;
        e.target.style.color = '#fff';
      }

      if (e.target.querySelector('.MuiButton-label') !== null) {
        e.target.style.background = buttonTextColor;
        e.target.querySelector('.MuiButton-label').style.color = '#fff';
      }
    }

    function onMouseOut(e) {
      if (e.currentTarget !== null) {
        e.currentTarget.style.background = buttonBgColor;
        e.target.style.color = buttonTextColor;
      }
      if (e.target.querySelector('.MuiButton-label') !== null) {
        e.target.style.background = buttonBgColor;
        e.target.querySelector(
          '.MuiButton-label',
        ).style.color = buttonTextColor;
      }
    }

    return (
      <Grid>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          type="button"
          disabled={this.props.disabled}
          className={clsx(classes.borderButton, this.props.className)}
          onMouseOver={e => {
            onMouseOver(e);
          }}
          onMouseOut={e => {
            onMouseOut(e);
          }}
          onClick={
            this.props.link
              ? () =>
                  this.props.history &&
                  this.props.history.push({
                    pathname: this.props.link,
                  })
              : () => this.props.onClick()
          }
          {...this.props}
        >
          {this.props.button_name}
        </Button>
      </Grid>
    );
  }
}

export default withStyles(styles)(ButtonComponent);
